<template>
    <div class="flex flex-col-reverse md:grid md:grid-cols-12 wrapper-page">
        <div class="col-start-1 col-span-7 came-up-section-up px-5 md:pr-0 py-6 md:py-10 flex">
            <slot name="firstCol" />
        </div>
        <div class="col-start-8 col-span-5 note-picture md:overflow-hidden py-6 md:py-10 animated ani-right-to-left-screen">
            <slot name="secondCol" />
        </div>
    </div>
</template>

<style lang="postcss" scoped>
:deep() {
    .came-up-section-up {
        & > :first-child > :first-child {
            max-width: 500px;
        }
        @media (max-width: 767px) {
            border-radius: 0 160px 0 0;
            background-color: #E2F1FA;

            @apply pt-16;
        }
    }

    .note-picture > img {
        @media (max-width: 767px) {
            width: 100% !important;
            height: auto !important;
            position: relative;
            bottom: -80px;
            z-index:1;

            @apply px-5;
        }

        @media (min-width: 768px) {
            height:100%;
            width:auto;
            max-width: fit-content;

        }
    }
}
</style>
